<rt-collapsible-card uniqKey="candidate-offer-evaluation-summary">
  <div leftSlot layout layout-align-items-center>
    <rt-heading variant="heading large">
      {{ 'app.evaluation_tab.summary' | translate }}
    </rt-heading>
  </div>

  <div
    collapsible
    class="content"
    [class.content--single-chart]="hasSingleChart()"
    layout-horizontal
    layout-space-between
    padding-lr
    padding-bottom
  >
    @if (summary().hasHiddenEvaluations) {
      <div class="details details--hidden" layout-vertical layout-justify-center margin-right>
        <div class="hidden-title" layout layout-align-items-center>
          <rt-icon
            name="visibility-off"
            size="medium"
            colorToken="colorIconLowDisabled"
            margin-right-small-x
          />
          <span class="evaluations-count">
            {{ 'app.evaluation_tab.summary_details.average_evaluation_score' | translate }}
          </span>
        </div>
        <span class="description">
          {{ 'app.evaluation_tab.summary_details.hidden_description' | translate }}
        </span>
        @if (canReveal()) {
          <div class="reveal-button">
            <rt-button variant="tertiary" (click)="revealForMe.emit()">
              <rt-icon prefix name="visibility" />
              {{ 'app.evaluation_tab.summary_details.reveal_for_me' | translate }}
            </rt-button>
          </div>
        }
      </div>
    } @else {
      <div class="details" layout layout-align-items-center>
        @if (summary().reviewers?.length) {
          <rt-admins-avatars
            [admins]="$any(summary().reviewers)"
            [stacked]="true"
            [limit]="3"
            [moreButtonAsCounter]="true"
            [counterAvatarTemplate]="counterAvatarTemplate"
            avatarSize="nav-item"
          />

          <ng-template #counterAvatarTemplate>
            <div class="avatar-counter">{{ summary().reviewers.length }}</div>
          </ng-template>
        }

        <div layout-vertical layout-justify-center margin-right>
          <span class="evaluations-count">
            {{
              'app.evaluation_tab.summary_details.evaluations_added'
                | translate: { count: summary().evaluationsCount }
            }}
          </span>
          <span
            class="description"
            [innerHTML]="
              'app.evaluation_tab.summary_details.team_members_evaluated'
                | translate: { count: summary().reviewersCount }
            "
          ></span>
          @if (summary().lastEvaluation; as lastEvaluation) {
            @if (lastEvaluation.stage; as stage) {
              <span
                class="description"
                [innerHTML]="
                  'app.evaluation_tab.summary_details.last_evaluated'
                    | translate
                      : {
                          timeAgo: lastEvaluation.evaluatedAt | rtTimeAgo,
                          stageName: stage.name,
                        }
                "
              ></span>
            } @else {
              <span
                class="description"
                [innerHTML]="
                  'app.evaluation_tab.summary_details.last_evaluated_without_stage'
                    | translate: { timeAgo: lastEvaluation.evaluatedAt | rtTimeAgo }
                "
              ></span>
            }
          }
        </div>
      </div>
    }

    @if (theme(); as theme) {
      <div class="charts" layout layout-align-items-center>
        @if (evaluationScale(); as evaluationScale) {
          <rt-candidate-ratings-score-chart
            [evaluationScale]="evaluationScale"
            [score]="summary().score"
            [isHidden]="summary().hasHiddenEvaluations"
            [showTooltip]="true"
            [theme]="theme"
          />
        }

        @if (summary().skills; as skills) {
          <rt-candidate-skills-chart
            [skills]="skills"
            [size]="130"
            [isHidden]="summary().hasHiddenEvaluations"
            [theme]="theme"
            [thickness]="15"
            [showTooltip]="true"
            [labelFontSize]="11"
          />
        }
      </div>
    }
  </div>
</rt-collapsible-card>
